import { render } from "./QueueAccount.vue?vue&type=template&id=74405ebf&scoped=true"
import script from "./QueueAccount.vue?vue&type=script&lang=js"
export * from "./QueueAccount.vue?vue&type=script&lang=js"

import "./QueueAccount.vue?vue&type=style&index=0&id=74405ebf&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74405ebf"]])

export default __exports__